import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

export const LoadableConfirmNavigationDialog = lazyLoadOnRender({
  loader: () =>
    import(/* webpackChunkName: "4-feat-confirm-navigation-dialog" */ './ConfirmNavigationDialog').then(
      ({ ConfirmNavigationDialog }) => ({
        default: ConfirmNavigationDialog,
      })
    ),
});
